// Mirror of apps/api/apps/cards/pricing.compute_buyer_price. Keep in sync.
// Rounding MODE intentionally differs from the backend: this is JS
// half-up (round2 below) while the backend quantizes with Decimal's
// ROUND_HALF_EVEN default. This is a display-preview-only mirror — the
// backend is authoritative on save, so any half-cent discrepancy here never
// reaches the persisted price.
const round2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100;

export function computeBuyerPrice({
  mode,
  frame,
  markupPercent,
  priceFloor,
  fixedValue,
  marketPrice,
  feeRate,
}) {
  const f = Number(feeRate) || 0;
  let target;
  if (mode === 'fixed') {
    if (fixedValue === '' || fixedValue == null) return null;
    target = Number(fixedValue);
  } else {
    const m = Number(marketPrice);
    if (!m || m <= 0) return null;
    target = m * (1 + Number(markupPercent || 0) / 100);
    if (priceFloor !== '' && priceFloor != null) target = Math.max(Number(priceFloor), target);
  }
  const b = frame === 'inclusive' ? target : target / (1 - f);
  return round2(b);
}

export function priceBreakdown(buyerPrice, feeRate) {
  const b = Number(buyerPrice) || 0;
  const fee = round2(b * (Number(feeRate) || 0));
  return { buyer: round2(b), fee, net: round2(b - fee) };
}

// The backend refuses a tracked listing with no markup_percent, and the
// preview above reads a blank markup as 0%, so check it before posting.
// 0 is a real answer; a blank is not.
export function trackedMarkupError({ mode, markupPercent }) {
  if (mode !== 'tracked') return null;
  const raw = markupPercent == null ? '' : String(markupPercent).trim();
  if (raw === '' || !Number.isFinite(Number(raw))) {
    return 'Enter a markup percentage, or 0 to sell at the market price.';
  }
  return null;
}
